// ---------------------------------------------------------------------------
// Block Definition: section (DocDsl)
//
// Page section container — groups blocks on a DocDsl page.  Pure layout,
// no data extraction.
// ---------------------------------------------------------------------------

export const sectionDef = {
  type: "section",
  label: "Section",
  description: "Page section container for grouping blocks.",

  crystallizer: null,

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "layout",
    category: "layout",
    defaultTemplate: { type: "section", children: [] },
  },
};
